import { Box, Loading } from '@fe-toolkit/web-components/ssr'

export default function FullPageLoader() {
  return (
    <Box
      sx={({ theme }) => ({
        backgroundColor: theme.colors.wildSand,
        padding: '1px',
      })}
    >
      <Box
        sx={({ theme }) => ({
          maxWidth: theme.layout.maxWidth,
          margin: `0 auto`,
          height: '50vh',
          minHeight: '600px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          padding: theme.spacing.small,
          [theme.breakpoints.up('medium')]: {
            paddingTop: theme.spacing.medium,
          },
        })}
      >
        <Loading />
      </Box>
    </Box>
  )
}
